import { ReactNode } from 'react'
import { Box, Typography } from '@mui/material'

import { PageContentLayout } from '@layouts/PageContentLayout'
import { PageTitle } from '@components/PageTitle'

type ConfigListPageShellProps = {
  title: string
  isVisible?: boolean
  actions?: ReactNode
  children: ReactNode
}

export const ConfigListPageShell = ({
  title,
  isVisible = true,
  actions,
  children,
}: ConfigListPageShellProps) => {
  return (
    <Box sx={{ ...(isVisible ? {} : { display: 'none' }), flex: 1 }}>
      <PageContentLayout sx={{ p: 1 }}>
        <PageTitle
          end={false}
          start={
            <Typography display='inline' sx={{ mr: 1, ml: 1 }} variant='h6'>
              {title}
            </Typography>
          }
        />
        {actions && <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}>{actions}</Box>}
        {children}
      </PageContentLayout>
    </Box>
  )
}
